import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator } from '@angular/forms';

export function minMaxValidator(min: number, max: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null; // Don't validate empty values
    }

    if (value < min) {
      return { min: { requiredMin: min, actualValue: value } };
    }

    if (value > max) {
      return { max: { requiredMax: max, actualValue: value } };
    }

    return null; // Valid value
  };
}

@Directive({
  selector: '[minMaxValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MinMaxValidatorDirective,
      multi: true,
    },
  ],
})
export class MinMaxValidatorDirective implements Validator {
  @Input() minMaxValidator: { min: number; max: number } = { min: 0, max: 0 };

  validate(control: AbstractControl): ValidationErrors | null {
    return minMaxValidator(this.minMaxValidator.min, this.minMaxValidator.max)(control);
  }
}